/**
 * @author wuTao
 * @description 资源列表
 * @Date 2022/04/15
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,utils_tool ,component_tool} from '@/tool';
import moment from "moment";
let { WizContainer, WizReduxTemplate } = framework_tool;
let { checkStrLength } = utils_tool;
let {  WizBrowserExport } = component_tool;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYYMMDDHHmm') : '';
}
const formatterDay = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
class InteractLiveHktResources extends WizContainer {

  componentName = 'interactLiveHktResources';

  constructor(props) {
    super(props);
    this.state = {
      AddTimestamp: new Date().getTime()
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _templateConfig = templateConfig(this)
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:_templateConfig,
      apiDataFormat: {
        export: this._handleFile,
        batchCreateZoomUserResources: this._handleCMD,
        updateStatus: this._handleCMD,
        batchSyncUserResourcesUserType: this._handleCMD,
      },

    })
    return <WizReduxTemplate {..._reduxTemplateCofig}  />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(InteractLiveHktResources);
